import type { ReactNode, MouseEvent } from "react";

import type { IButtonProps } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";

type SeeAllButtonProps = Pick<IButtonProps, "isDisabled"> & {
    children: ReactNode;
    dataAutomation: string;
    onClick: () => void;
};

export const SeeAllButton = ({ onClick, dataAutomation, ...other }: SeeAllButtonProps) => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick();
    };

    return (
        <Button
            {...other}
            onClick={handleClick}
            type="flat"
            width="fit-content"
            data-automation={dataAutomation}
        />
    );
};
